<script setup>

const dairamon = useDairamon();
const { data: page} = await dairamon.pages.get(86);
const htmlContent = ref(page.value.values[0].value);

//const { data } = await dairamon.customers.list(/*{ email: 'attila@sztanki.com' }*/);
// const { data } = await dairamon.customers.get(4866);
//
//
// //const { data } = await dairamon.customers.get();
//
const customer = {
  email: 'kitti@peter2.com',
  firstname: 'Kitti',
  lastname: 'Péter',
  is_company: true,
  name: 'Kitti Péter Kft',
 // country_id: 'HU',
}

//const { data: user } = await dairamon.customers.create(customer)


//const user = await dairamon.customers.findByEmail('jane@dduram.com')

// const address = {
//   partner_id: 4880,
//   firstname: 'Kitti',
//   lastname: 'Péter',
//   zip: 1044,
//   city: 'Budapest',
//   street: 'Lajos',
//  // publicplace_name: 'Kossuth Lajos',
// //  is_default: true,
//  // company: 'Kitti Péter Kft',
//  // street: 'Kossuth Laj'
// }
//
// // const { data: customAddress } = await dairamon.customers.addresses.create(address)
// // console.log(customAddress)
// const { data: customAddress } = await dairamon.customers.addresses.list()
// console.log(customAddress.value)

// //const user = await dairamon.customers.create(customer)
//
// //const user = await dairamon.customers.create(customer)
//
const items = [
  {
    product_id: 58,
    qty: 4,
  },
  {
    product_id: 2,
    qty: 6,
  },
];
//
// const { data: user } = await dairamon.customers.get(4880);
// const { data } = await dairamon.orders.create({ partner_id: user.value.id, name: user.value.name, address: user.value.addresses[0] }, items);
// console.log(user.value.id)
//console.log(user)


//const { data: customer } = await dairamon.customers.get(4864);
//const { data: customer } = await dairamon.customers.list();


onMounted(() => {
 // console.log(customer)
})

</script>

<template>
  <div>
    <h1> {{ page.title }}</h1>
    <div v-html="htmlContent"></div>
  </div>
</template>


